import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// Utilities
import { mapState } from 'vuex';
export default {
  name: 'CoreToolbarMenu',
  props: {
    canCreateTickets: {
      type: Boolean,
      default: false
    },
    newTicketCount: {
      type: Number,
      default: 0
    },
    showTicketNotificationBell: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      externalLink: false
    };
  },
  computed: _objectSpread({}, mapState('app', ['color'])),
  methods: {
    getPath: function getPath(metaObj) {
      if (metaObj && metaObj.help) {
        this.externalLink = true;
        return "".concat(this.$store.state.app.docsBaseURL, "/").concat(metaObj.help.path);
      } else {
        this.externalLink = false;
        return '/#/help';
      }
    },
    logout: function logout() {
      this.$emit('logout');
    }
  }
};